import { Tag } from '../../../models';
import { TagDto } from '../../../services/dtos/tags/tag.dto';

export const mapTagsIdsToTags = (tagsIds: string[], tags: Record<string, TagDto>): Tag[] =>
  tagsIds
    .filter((tagId) => tags[tagId])
    .map((tagId) => {
      const match = tags[tagId];

      return {
        name: match.name,
        tagId: match.tagId,
        ticker: match?.ticker,
      };
    });
